import { type OpTableRecordType, type TableState } from '../OpTableCore/types';

import { QueryStringParams } from './types';

// Make options list to pass to API:
// 1) Options are not variable (no columns with optionsRequired); nothing to do
// 2) Some are optional (queryStringParams has options already and there are columns with optionsRequired)
// 3) All are optional (queryStringParams has no options but there are columns with optionsRequired)
export const dynamicallyPopulateQueryOptions = <T extends OpTableRecordType>({
  tableState,
  queryOptions,
}: {
  tableState: TableState<T>;
  queryOptions?: QueryStringParams['options'];
}): string => {
  const hasBaseOptions = (queryOptions?.length ?? 0) > 0;
  const neededOptions = new Set<string>(
    hasBaseOptions ? queryOptions!.split(',') : null,
  );
  // We currently clear the sort and filter on a column if it gets hidden
  // If that changes this needs to change too
  tableState.columns
    .filter((col) => col.optionsRequired && !col.hidden)
    .forEach((col) => {
      if (Array.isArray(col.optionsRequired)) {
        col.optionsRequired.forEach((opt) => neededOptions.add(opt));
      } else {
        neededOptions.add(col.optionsRequired!);
      }
    });
  // This will be '' if no options are needed
  return [...neededOptions].join(',');
};
